import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import { usePreviewMode } from './usePreviewMode';

interface AlternativeRedirectProps {
  from: string;
  to: string;
}

export const useAlternativeRedirect = ({ from, to }: AlternativeRedirectProps): void => {
  const navigate = useNavigate();
  const location = useLocation();
  const preview = usePreviewMode();

  useEffect(() => {
    if (location.pathname === from) {
      navigate(preview ? `${to}?preview=${preview}` : to, {
        replace: true,
      });
    }
  }, [navigate, preview, location.pathname, from, to]);
};
